var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"daterange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","value-format":_vm.valueFormat,"clearable":_vm.clearable},on:{"change":_vm.handleChange},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})
}
var staticRenderFns = []

export { render, staticRenderFns }